import { themeVars } from '@styles/themes.css';
import { styleVariants } from '@vanilla-extract/css';

const MOBILE = '(max-width: 64em)';

export const variants = styleVariants({
  h1: {
    fontFamily: themeVars.font.Magenos,
    fontSize: '4rem',
    lineHeight: 1.2,
    fontWeight: 900,
    '@media': { [MOBILE]: { fontSize: '2.25rem' } },
  },
  h2: {
    fontFamily: themeVars.font.Magenos,
    fontSize: '2.25rem',
    lineHeight: 1.2,
    fontWeight: 600,
    '@media': { [MOBILE]: { fontSize: '1.75rem' } },
  },
  h3: {
    fontFamily: themeVars.font.Magenos,
    fontSize: '1.75rem',
    lineHeight: 1.2,
    fontWeight: 600,
    '@media': { [MOBILE]: { fontSize: '1.25rem' } },
  },
  h4: {
    fontFamily: themeVars.font.Magenos,
    fontSize: '1.25rem',
    lineHeight: 1.2,
    fontWeight: 600,
    '@media': { [MOBILE]: { fontSize: '1.125rem' } },
  },
  h5: {
    fontFamily: themeVars.font.Magenos,
    fontSize: '1.125rem',
    lineHeight: 1.2,
    fontWeight: 600,
    '@media': { [MOBILE]: { fontSize: '1rem' } },
  },
  h6: {
    fontFamily: themeVars.font.Magenos,
    fontSize: '1rem',
    lineHeight: 1.2,
    fontWeight: 600,
    '@media': { [MOBILE]: { fontSize: '0.875rem' } },
  },
  body1: {
    fontFamily: themeVars.font.Roboto,
    fontSize: '1.125rem',
    lineHeight: 1.5,
    fontWeight: 400,
  },
  body2: {
    fontFamily: themeVars.font.Roboto,
    fontSize: '1rem',
    lineHeight: 1.5,
    fontWeight: 400,
  },
  body3: {
    fontFamily: themeVars.font.Roboto,
    fontSize: '0.875rem',
    lineHeight: 1.5,
    fontWeight: 400,
  },
});
